import { render } from "./OrganizerEvents.vue?vue&type=template&id=483ae7cb&scoped=true"
import script from "./OrganizerEvents.vue?vue&type=script&lang=js"
export * from "./OrganizerEvents.vue?vue&type=script&lang=js"

import "./OrganizerEvents.vue?vue&type=style&index=0&id=483ae7cb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-483ae7cb"

export default script